import { child, get, orderByChild, query, ref } from "firebase/database";
import { db, dbRef } from "../firebase/firebase";

export async function getBlogList(postId: string = "") {
  const snapshot = await get(
    query(ref(db, `blogPostList/english/${postId}`), orderByChild("postDateTs"))
  );
  return snapshot.exists() ? snapshot : null;
}

export async function getBlogDetails(postId: string) {
  const snapshot = await get(child(dbRef, `blogPostDetails/english/${postId}`));
  return snapshot.exists() ? snapshot : null;
}
